<template>
  <div class="flex items-center gap-0.5 justify-self-end z-[calc(var(--z-system)+1)] cursor-pointer [-webkit-app-region:no-drag]">
    <div :class="[WINBTN, WINBTN_HOVER]" @click="send('mainMinimize')">
      <svg class="size-5" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round">
        <path d="M4.25 8h7.5" />
      </svg>
    </div>
    <div :class="[WINBTN, WINBTN_HOVER]" v-if='!maximized' @click="send('mainMaximize')">
      <svg class="size-5" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round">
        <rect x="4.25" y="4.25" width="7.5" height="7.5" rx="1" />
      </svg>
    </div>
    <div :class="[WINBTN, WINBTN_HOVER]" v-else @click="send('mainUnmaximize')">
      <svg class="size-5" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round">
        <rect x="4.25" y="6.25" width="5.5" height="5.5" rx="1" />
        <path d="M6.25 4.25h4.5a1 1 0 0 1 1 1v4.5" />
      </svg>
    </div>
    <div :class="[WINBTN, 'hover:bg-red hover:text-white']" @click="send('mainHide')"><IconXMark16Solid class="size-5" /></div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { IconXMark16Solid } from '@iconify-prerendered/vue-heroicons';

const WINBTN = `flex items-center justify-center size-8 rounded-control
  text-text-muted transition-[background-color,color] duration-150`;
const WINBTN_HOVER = 'hover:bg-hover hover:text-text';

const maximized = ref(false);

window.APP_TRON.ipcRenderer.on('maximized', (_, state) => {
  maximized.value = state;
});

const send = (channel) => window.APP_TRON.ipcRenderer.send(channel);
</script>
